import React, {useEffect, useState}				from 'react';

import './Switch.css';

interface Props {
	readOnly?: boolean,
	active?: boolean,
	onChange?: (newVal: boolean) => void,
	text?: string,
	infoText?: string,
	style?: React.CSSProperties
}

function Switch(props: Props) {
	const [isFocused, set_isFocused] = useState(false);
	const [allowAnim, set_allowAnim] = useState(false);

	useEffect(() => {
		if (props.active)
			set_allowAnim(true);
	}, []);

	const onClick = () => {
		if (props.readOnly)
			return;

		if (!allowAnim)
			set_allowAnim(true);

		if (props.onChange)
			props.onChange(!props.active);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter' && isFocused && !props.readOnly)
			onClick();
	};

	return (
		<div className={'switchMainContainer'} style={props.style || {}}>
			<div
				tabIndex={0}
				role={'switch'}
				onClick={onClick}
				onKeyDown={handleKeyDown}
				aria-checked={props.active || false}
				onFocus={() => set_isFocused(true)}
				onBlur={() => set_isFocused(false)}
				className={`switch ${props.active && 'active'} ${props.readOnly && 'readOnly'} ${allowAnim && 'anim'}`}
			>
				<div />
			</div>
			<div className={'switchTextContainer'}>
				{props.text && <span className={'switchText'}>{props.text}</span>}
				{props.infoText && <span className={'switchInfoText'}>{props.infoText}</span>}
			</div>
		</div>
	);
}

export default Switch;
